module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_6005.efad9fa8.png";